// @flow

import type { StoreResourceDef } from 'app/core/types'

export const departments: StoreResourceDef<> = {
  resourceType: 'departments',
}
